// extracted by mini-css-extract-plugin
export default {"thmBtn":"ThemeBtn_thmBtn__pLBEG","clrWhite":"ThemeBtn_clrWhite__S2b3F","tbSmall":"ThemeBtn_tbSmall__MORIF","btnIcon":"ThemeBtn_btnIcon__6PX71"};